import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as ordersApi from "../../services/orders";
import { errorMessage } from "../../services";
import { logout } from "./authSlice";

// Orders of the website being managed, loaded page by page from the API
export const fetchOrders = createAsyncThunk("order/fetchOrders", async ({ siteId, params }, { rejectWithValue }) => {
  try {
    const { data } = await ordersApi.getOrders(siteId, params);
    return data;
  } catch (err) {
    return rejectWithValue(errorMessage(err));
  }
});

const initialState = {
  orders: [],
  stats: { all: 0, pending: 0, shipped: 0, delivered: 0, revenue: 0 },
  total: 0,
  page: 1,
  pages: 1,
  loading: false,
  error: null,
  requestId: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    // Swap one order after it was edited, without reloading the list
    updateSingleOrder: (state, action) => {
      state.orders = state.orders.map((order) => (order.id === action.payload.id ? action.payload : order));
    },
  },
  extraReducers: (builder) => {
    builder
      // Nothing from one user's session may show up for the next person who signs in
      .addCase(logout, () => initialState)
      .addCase(fetchOrders.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.requestId = action.meta.requestId;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        const { orders, stats, total, page, pages } = action.payload;
        Object.assign(state, { orders, stats, total, page, pages, loading: false });
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { updateSingleOrder } = orderSlice.actions;
export default orderSlice.reducer;
